export function getPrimaryText(tabTitle) {
    switch (tabTitle) {
        case 'Incoming':
            return 'Inbox';
        case 'Outgoing':
            return 'Sent';
        default:
            return tabTitle;
    }
}